export default "__VITE_ASSET__sDpSG8Za__"